import * as React from 'react';

import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { SecurityData, RouterData } from '../shared/index';
import { HotelBedData } from '../shared/index';
import { SearchForm } from '../core/SearchForm';
// import * as moment from 'moment';
import { HomeBanner } from './HomeBanner';
import { Homesection1 } from './Homesection1';
import { Homesection2 } from './Homesection2';
import { Homesection3 } from './Homesection3';
import { Homesection4 } from './Homesection4';
import { Homesection5 } from './Homesection5';
import { Homesection6 } from './Homesection6';
import { HomeHotelParner } from './HomeHotelParner';
import { HomeFlightBanner } from './HomeFlightBanner'; 
export interface DefaultPageProps extends BaseComponentProps {
    lang: string;
    currency: string;
    user: SecurityData.ApplicationUser;
    user_login: boolean;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    history: RouterData.History;
    count?: number;
    externalFilter?: HotelBedData.ExternalFilter;
    /** 
     * filter awal untuk data
     */
    initialFilter: HotelBedData.SearchFilter;
}
export interface DefaultPageState extends BaseComponentState {
    // startDate: any;
    // endDate: any;
    room: string;
    guest: string;
    selectCreatable: boolean;
    selectValue: string;
    selectMulti: boolean;
    backspaceRemoves: boolean;
}

/** 
 * panel untuk landing page
 */
export class DefaultPage extends BaseComponent<DefaultPageProps, DefaultPageState> {
    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['lang', 'currency', 'user_login', 'user'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = [];

    constructor(props: DefaultPageProps) {
        super(props);
        // let m1: any = moment();
        // let m2: any = moment().add(1, 'day');
        this.state = {
            // startDate: m1,
            // endDate:  m2 ,
            room: '0',
            guest: '0',
            selectCreatable: false,
            selectValue: '',
            selectMulti: false,
            backspaceRemoves: true
        };
        
    }
    shouldComponentUpdate(nextProps: DefaultPageProps, nextState: DefaultPageState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(DefaultPage.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(DefaultPage.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;
    } 
    
    roomHandleChange = (room: any) => {
        this.setState({ room });
    }
    guestHandleChange = (guest: any) => {
        this.setState({ guest });
    }

    toggleCreatable = () => {
        this.setState({
            selectCreatable: !this.state.selectCreatable
        });
    }

    onChange = (value: any) => {
        this.setState({
            selectValue: value,
        });
    }

    render(): JSX.Element {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        /*
        let userId: any = "";
        if (this.props.user) {
            userId = this.props.user.uuid;
        }
        let scKey = `${btoa(JSON.stringify(this.props.initialFilter))}${userId}`;
        */
        return (
            <div >
                <HomeBanner lang={this.props.lang} />
                <div className="container search-form">
                    <div className=" col-md-12">
                        <SearchForm
                            externalFilter={this.props.externalFilter!}
                            lang={this.props.lang}
                            showtitle={false}
                            style='horisontal'
                            count={this.props.count!}
                            getHotels={this.props.getHotels} 
                            filter={this.props.initialFilter}
                            /* key={scKey} */
                        />
                    </div>
                </div>
                <Homesection1 lang={this.props.lang} />
                <Homesection3 lang={this.props.lang}/>
                <Homesection4 />
                <HomeFlightBanner/>
                <Homesection2 history={this.props.history} lang={this.props.lang} currency={this.props.currency} />  
                <Homesection5 lang={this.props.lang}/> 
                <HomeHotelParner />
                <Homesection6 history={this.props.history} lang={this.props.lang} currency={this.props.currency} />  
                 
            </div>);
    }

}


// WEBPACK FOOTER //
// ./src/home/DefaultPage.tsx